import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, ResolveEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, Subject, takeUntil } from 'rxjs';
import { MonitoringService } from './services/monitoring.service';

import * as fromUser from './store/fromUser.barrel'
import * as fromRouter from './store/selectors/router.selectors';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject();

  constructor(
    private monitoringService: MonitoringService,
    private store: Store<fromUser.State>,
    private title: Title,
    private router: Router
  ) {
    this.monitoringService.logTrace('App Started');
  }

  ngOnInit(): void {
    this.logPageView();
    // this.logUserEvents();
  }

  logUserEvents() {
    this.store.select(fromUser.selectUserProfile)
      .pipe(takeUntil(this.unsubscribe$), filter(f => !!f))
      .subscribe(profile => this.monitoringService.logTrace(`${profile?.username}`,
        {
          'authenticated': profile?.isAuthenticated,
          'username': profile?.username,
          'authType': profile?.authType,
          'claims': JSON.stringify(profile?.claims),
          'companyAccesses': JSON.stringify((profile?.companyAccesses || []).map(m => `${m.company?.name}|${m.role?.name}`))
        }));
  }

  logPageView() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const activatedComponent = this.getActivatedComponent(event.state?.root || {});
        if (!!activatedComponent) this.monitoringService.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects)
      });
  }
  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (!!snapshot.firstChild) return this.getActivatedComponent(snapshot.firstChild);
    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '';
    if (!!snapshot.routeConfig) path += snapshot.routeConfig.path;
    if (!!snapshot.firstChild) return path + this.getRouteTemplate(snapshot.firstChild);
    return path;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

}
